(function () {
  "use strict";

  var body = document.body;
  var drawers = {
    bag: document.getElementById("bag"),
    menu: document.getElementById("menu"),
  };
  var triggers = {
    bag: document.querySelector("[data-open-bag]"),
    menu: document.querySelector("[data-open-menu]"),
  };
  var activeId = null;
  var returnFocus = null;

  function focusableElements(drawer) {
    return Array.prototype.slice
      .call(
        drawer.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
        ),
      )
      .filter(function (element) {
        return !element.hidden && element.getClientRects().length;
      });
  }

  function setDrawerState(id, open) {
    var drawer = drawers[id];
    var trigger = triggers[id];
    if (!drawer) return;
    drawer.setAttribute("aria-hidden", open ? "false" : "true");
    if (open) drawer.removeAttribute("inert");
    else drawer.setAttribute("inert", "");
    if (trigger) trigger.setAttribute("aria-expanded", open ? "true" : "false");
  }

  function syncDrawers() {
    var nextId = body.classList.contains("bag-open")
      ? "bag"
      : body.classList.contains("menu-open")
        ? "menu"
        : null;

    setDrawerState("bag", nextId === "bag");
    setDrawerState("menu", nextId === "menu");

    if (nextId && nextId !== activeId) {
      activeId = nextId;
      window.requestAnimationFrame(function () {
        var first = focusableElements(drawers[nextId])[0];
        if (first) first.focus();
      });
    } else if (!nextId && activeId) {
      activeId = null;
      if (returnFocus && document.contains(returnFocus)) returnFocus.focus();
      returnFocus = null;
    }
  }

  document.addEventListener(
    "click",
    function (event) {
      var opener = event.target.closest("[data-open-bag], [data-open-menu]");
      if (opener) returnFocus = opener;
    },
    true,
  );

  document.addEventListener("keydown", function (event) {
    if (!activeId || event.key !== "Tab") return;
    var items = focusableElements(drawers[activeId]);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  new MutationObserver(syncDrawers).observe(body, {
    attributes: true,
    attributeFilter: ["class"],
  });
  syncDrawers();

  var footer = document.querySelector("footer");
  if (footer && "IntersectionObserver" in window) {
    new IntersectionObserver(
      function (entries) {
        body.classList.toggle("footer-in-view", entries[0].isIntersecting);
      },
      { threshold: 0.08 },
    ).observe(footer);
  }

  var stickyBuy = document.getElementById("sbuy");
  if (stickyBuy) {
    function syncStickyBuy() {
      body.classList.toggle(
        "sticky-buy-visible",
        stickyBuy.classList.contains("show"),
      );
    }
    new MutationObserver(syncStickyBuy).observe(stickyBuy, {
      attributes: true,
      attributeFilter: ["class"],
    });
    syncStickyBuy();
  }
})();
